import CorporateClientModel from "./corporate_client.model";
import { CrudModel } from "./_crud";

export class SolutionFavoriteCorporateClientModel extends CrudModel {
	constructor() {
		super("admin/solutionFavoriteCorporateClient", [], [{ fieldKey: "corporateClient", model: CorporateClientModel }]);
	}
}

export default new SolutionFavoriteCorporateClientModel();
